import { render, staticRenderFns } from "./HumanUserNewEditDialog.vue?vue&type=template&id=33236cbc&scoped=true"
import script from "./HumanUserNewEditDialog.vue?vue&type=script&lang=js"
export * from "./HumanUserNewEditDialog.vue?vue&type=script&lang=js"
import style0 from "./HumanUserNewEditDialog.vue?vue&type=style&index=0&id=33236cbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33236cbc",
  null
  
)

export default component.exports